import { BusinessProvider } from "../../contexts/BusinessContext";
import SettingInformation from "./components/SettingsInformation";
import { Route, Routes } from "react-router-dom";
import BusinessPage from "./components/Business/BusinessPage";
import BillingPage from "./components/Billing";
import SettingsHome from "./components/Home";
import UserInformation from "./components/User/UserInformation";
import Integrations from "./components/Integrations";
import ReportsSettings from "./components/Reports";
import EmailSettings from "./components/Email";
import CheckInSettings from "./components/CheckIn";
import PaymentsSettings from "./components/Payments";

export default function SettingsPage() {
  return (
    <BusinessProvider>
      <Routes>
        <Route path="/" element={<SettingsHome />} />
        <Route path="/settings" element={<SettingInformation />} />
        <Route path="/business" element={<BusinessPage />} />
        <Route path="/billing" element={<BillingPage />} />
        <Route path="/user" element={<UserInformation />} />
        <Route path="/integrations" element={<Integrations />} />
        <Route path="/reports" element={<ReportsSettings />} />
        <Route path="/email" element={<EmailSettings />} />
        <Route path="/checkin" element={<CheckInSettings />} />
        <Route path="/payments" element={<PaymentsSettings />} />
      </Routes>
    </BusinessProvider>
  );
}
